import { useQuery } from "@tanstack/react-query";
import { GatewayService, type SessionInfo } from "../api/gateway.service";

/** State and actions returned by {@link useUserSessions}. */
export interface UseUserSessionsReturn {
    sessions: SessionInfo[];
    loading: boolean;
    error: Error | null;
    /** Re-run the query for the current user's sessions. */
    refetch: () => void;
}

/** Admin view of a given user's active device sessions. Disabled when `userId` is null. */
export const useUserSessions = (userId: number | null): UseUserSessionsReturn => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["gateway", "user-sessions", userId],
        queryFn: ({ signal }) => GatewayService.getUserSessions(userId as number, { signal }),
        enabled: userId != null,
    });
    return {
        sessions: data ?? [],
        loading: isLoading,
        error,
        refetch: () => { void refetch(); },
    };
};
